function resourceModel() {
  this.$get = function $get_resourceCategoryModel(ResourceListBuilder) {
    return {
      model: {},

      update: function update_resourceModel(data) {
        var listToAdd = new ResourceListBuilder(data);
        _.forEach(
          listToAdd.resources,
          (resource) => (this.model[resource.id] = _.merge({}, this.model[resource.id], resource))
        );
        return this;
      },

      getResourceDetail: function getResourceDetail_resourceModel(id) {
        return this.model[id];
      },

      getResourcesByListOfIds: function getResourcesById_resourceModel(idArray) {
        return _.map(idArray, (id) => this.model[id]);
      },

      getResourcesByCategoryId: function getResourcesByCategoryId_resourceModel(categoryId) {
        return _.sortBy(
          _.filter(
            this.model,
            (res) => !_.isUndefined(res.resource_category) && res.resource_category.id === parseInt(categoryId, 10)
          ),
          'name'
        );
      },

      favoriteResourceById: function favoriteResourceById_resourceModel(id, favorite_id) {
        this.model[id].favorite_id = favorite_id;

        return this.model[id];
      },

      unfavoriteResourceById: function unfavoriteResourceById_resourceModel(id) {
        this.model[id].favorite_id = false;

        return this.model[id];
      },

      getFavoriteResources: function getFavoriteResources_resourceModel() {
        return _.filter(this.model, (res) => res.favorite_id);
      }
    };
  };
}

angular.module('capability-ng-resources').provider('resourceModel', resourceModel);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-resources/src/models/resource_model.es.js